export const generatePassword = () =>  {
  let text = "";
  const upperLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerLetters = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const symbols = "#$%&!?¡¿";

  for (let i = 0; i < 3; i++) {
    text += upperLetters.charAt(Math.floor(Math.random() * upperLetters.length));
    text += lowerLetters.charAt(Math.floor(Math.random() * lowerLetters.length));
    text += numbers.charAt(Math.floor(Math.random() * numbers.length));
    text += symbols.charAt(Math.floor(Math.random() * symbols.length));
  }

  return text;
}



// WEBPACK FOOTER //
// ./src/utils/password.js